<template>
	<div class="container-table">
		<span class="fields-maps">Campos Mapeados:</span>
		<ui-table :columns="tableColumns"
			:loading="loading"
			:select-column-menu="false"
			:data="contents"
			label="Campos Mapeados"
			class="scroll-color"
			name="mapsUntitsTable"
			tr-component="marketing/erp/product/unit-maps-fields-table"
			not-found-text="Não foi possível encontrar nenhuma Equipe"
			not-found-icon="fal fa-building"
		/>

		<ui-modal-message name="delete-erp-units-mapping"
			title="Deseja realmente excluir este mapeamento?"
			text="Cuidado, esta ação não poderá ser desfeita."
			service="erp"
			btn-type="danger"
			btn-text="Confirmar"
			icon="fal fa-trash-alt"
			color-circle="danger"
			icon-circle
		/>
	</div>
</template>

<script>
	import { uiTable } from '@/components/ui'
	import { uiModalMessage } from '@/components/ui/modal'

	export default {
		components: {
			uiTable,
			uiModalMessage
		},

		props: {
			contents: {
				type: [Array, Object],
				required: true
			},
			/**
			 * Define o status de loading da tabela
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false
			}
		},

		data() {
			return {
				tableColumns: [
					{
						title: 'Campo Facilita:',
					},
					{
						title: 'Campo ERP:',
					},
					{
						title: 'RegExp',
					},
					{
						title: 'Posição',
					},
					{ title: '' },
				],
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
